const daysMonths = {
  en: {
    translation: {
      january: "January",
      february: "February",
      march: "March",
      april: "April",
      may: "May",
      june: "June",
      july: "July",
      august: "August",
      september: "September",
      october: "October",
      nobember: "November",
      december: "December",
      month_01: "January",
      month_02: "February",
      month_03: "March",
      month_04: "April",
      month_05: "May",
      month_06: "June",
      month_07: "July",
      month_08: "August",
      month_09: "September",
      month_10: "October",
      month_11: "November",
      month_12: "December",
      graph_month_0: "January",
      graph_month_1: "February",
      graph_month_2: "March",
      graph_month_3: "April",
      graph_month_4: "May",
      graph_month_5: "June",
      graph_month_6: "July",
      graph_month_7: "August",
      graph_month_8: "September",
      graph_month_9: "October",
      graph_month_10: "November",
      graph_month_11: "December",
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday"
    }
  },
  it: {
    translation: {
      january: "Gennaio",
      february: "Febbraio",
      march: "Marzo",
      april: "Aprile",
      may: "Maggio",
      june: "Giugno",
      july: "Luglio",
      august: "Agosto",
      september: "Settembre",
      october: "Ottobre",
      nobember: "Novembre",
      december: "Dicembre",
      month_01: "Gennaio",
      month_02: "Febbraio",
      month_03: "Marzo",
      month_04: "Aprile",
      month_05: "Maggio",
      month_06: "Giugno",
      month_07: "Luglio",
      month_08: "Agosto",
      month_09: "Settembre",
      month_10: "Ottobre",
      month_11: "Novembre",
      month_12: "Dicembre",
      graph_month_0: "Gennaio",
      graph_month_1: "Febbraio",
      graph_month_2: "Marzo",
      graph_month_3: "Aprile",
      graph_month_4: "Maggio",
      graph_month_5: "Giugno",
      graph_month_6: "Luglio",
      graph_month_7: "Agosto",
      graph_month_8: "Settembre",
      graph_month_9: "Ottobre",
      graph_month_10: "Novembre",
      graph_month_11: "Dicembre",
      monday: "Lunedì",
      tuesday: "Martedì",
      wednesday: "Mercoledì",
      thursday: "Giovedì",
      friday: "Venerdì",
      saturday: "Sabato",
      sunday: "Domenica"
    }
  }
};

export default daysMonths;
